<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Bizimlə əlaqə</h1>
      </div>

      <div class="col-md-4">
        <div class="note">
          <p>Səhv və ya qeyri-dəqiqlik tapsanız, həmçinin təklif, rəy və iradlarınız varsa formanı doldurmaqla bizə məktub göndərməyinizi xahiş edirik.</p>
          <p>Bizi sosial şəbəkələrdə izləyərək ən son yeniliklərdən daha tez xəbərdar ola bilərsiniz:</p>
          <div class="social d-flex flex-column justify-content-center">
            <a href="https://www.facebook.com/azelocal/" target="_blank" rel="noreferrer">
              <img src="static/facebook.svg" alt="facebook"> azelocal
            </a>
            <a href="https://www.instagram.com/azelocal/" target="_blank" rel="noreferrer">
              <img src="static/instagram.svg" alt="instagram"> azelocal
            </a>
          </div>
          <p>Saytımızdan istifadə etdiyiniz üçün və dəyərli fikirlərinizi bizimlə bölüşdüyünüz üçün minnətdarıq!</p>
        </div>
      </div>

      <div class="col-md-8">
        <form @submit.prevent="checkForm">
          <div class="row">
            <div class="col-md-6">
              <input type="text" placeholder="Adınız" v-model="name">
            </div>
            <div class="col-md-6">
              <input type="email" placeholder="E-mail" v-model="email">
            </div>
            <div class="col-md-12">
              <textarea rows="10" placeholder="Mesajınız" v-model="message"></textarea>
            </div>
            <div class="col-md-12">
              <vue-recaptcha 
                sitekey="6LeJ8ZMUAAAAAFeF0ruaA0uOfcP2A1FGAyDGEXEi"
                ref="recaptcha"
                @verify="onVerify"
                @expired="onExpired">
              </vue-recaptcha>
              <br>
            </div>
            <div class="col-md-12">
              <input type="submit" value="Göndər" :disabled=isDisabled>
            </div>
            <div class="col-md-12">
              <p class="note" v-show="note.length">{{ note }}</p>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>

  import axios from 'axios';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    data(){
      return {
        name: '',
        email: '',
        message: '',
        note: '',
        success: false,
        isDisabled: false
      }
    },
    components: { 
      VueRecaptcha 
    },
    methods: {
      onVerify: function(response){
        this.success = true;
      },
      onExpired: function(){
        this.success = false;
        this.$refs.recaptcha.reset()
      },
      checkForm: function(e){
        if (this.name && this.email && this.message) {
          this.sendMail();
        } else {
          this.note = 'Xahiş edirik, bütün xanaları doldurun.'
        }
      },
      sendMail: function(){
        if(this.success) {
          this.isDisabled = true;
          let config = {
            headers: { 'content-type': 'multipart/form-data' }
          }
          let data = new FormData();
          data.append('name', this.name);
          data.append('email', this.email);
          data.append('message', this.message);

          axios.post('inc/mail.php', data, config)
          .then(response => {
            this.isDisabled = false;
            this.name = '',
            this.email = '',
            this.message = '',
            this.note = 'Mesajınız gönderildi! Təşəkkür edirik.'
          })
          .catch(error => {
            console.log(error);
          });
        } else {
          this.note = 'Xahiş edirik, robot olmadığınızı təsdiq edin.'
        }
      }
    }
  }
</script>

<style scoped>
form {
  margin-top: 2rem;
}
input,
textarea {
  margin-bottom: 1rem;
}
input[type="submit"] {
  transition: all 0.3s ease;
}
input[type="submit"]:disabled {
  background: #CCC;
}
.social a {
  color: #333;
  text-decoration: none;
  display: flex;
  align-items: center;
}
.social img {
  width: 16px;
  height: 16px;
  opacity: 0.6;
  margin-right: 10px;
}
  
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue